import { FC, memo } from 'react';

import { Table } from '../Table';
import { useDocumentActivitiesTable } from './hooks/useDocumentActivitiesTable';
import { DocumentActivitiesTableProps } from './types/DocumentActivitiesTableProps';

const DocumentActivitiesTableComponent: FC<DocumentActivitiesTableProps> = ({
  documentId,
  documentDefinition,
  searchParams,
  variant,
}) => {
  const { activities, meta, columns, tableProps } = useDocumentActivitiesTable({
    documentId,
    documentDefinition,
    searchParams,
  });

  return (
    <Table
      columns={columns}
      data={activities}
      meta={meta}
      variant={variant}
      {...tableProps}
    />
  );
};

export const DocumentActivitiesTable = memo(DocumentActivitiesTableComponent);
